import React from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { getContext } from 'common';
import { ListGroupHeading } from 'components/List';

export interface MoreButtonItemGroupHeaderProps extends React.ComponentPropsWithRef<'div'> {
  /** Group header. Consider using Typography component.  */
  children: React.ReactNode;
}

/** Group header for MoreButton menu items.
 * Any other props will be provided to the root element.
 */
const MoreButtonItemGroupHeader = React.forwardRef<HTMLElement, MoreButtonItemGroupHeaderProps>((props: MoreButtonItemGroupHeaderProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...otherProps
  } = props;
  const { style: userStyle, ...restOfOtherProps } = otherProps;

  return (
    <ListGroupHeading
      ref={ref}
      style={{
        paddingLeft: RTL ? undefined : `${Tokens.SPACING.SPACING_24}`,
        paddingRight: RTL ? `${Tokens.SPACING.SPACING_24}` : undefined,
        ...userStyle
      }}
      {...restOfOtherProps}
    >
      {children}
    </ListGroupHeading>
  );
}));

MoreButtonItemGroupHeader.displayName = 'MoreButtonItemGroupHeader';

export default MoreButtonItemGroupHeader;
